// Imagery below is the project's established generic sports-category
// photography (Unsplash, screened for third-party branding). The owner will
// replace these with Top Player's own approved photography.

const u = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&q=85&w=${w}`;

export const IMAGES = {
  heroHockey: u("photo-1485011151825-fa2f6224e540", 1920),
  hockeyJersey: u("photo-1695141683703-72ff11f64051"),
  hockeyStripe: u("flagged/photo-1550585477-a025700d7fce"),
  hockeyTeam: u("photo-1607863400985-8d3bc50e3fd6"),
  hockeyRink: u("photo-1632649177901-89d46eec248f"),
  hockeySkates: u("photo-1578742209329-d874efa53cb5"),
  hockeyPuck: u("photo-1516575448682-93a05df8bf59"),
  soccer: u("photo-1517927033932-b3d18e61fb3a"),
  soccerRun: u("photo-1560272564-c83b66b1ad12"),
  basketball: u("photo-1505666287802-931dc83948e9"),
  basketballGame: u("photo-1612768875331-0447b960fa40"),
  rugby: u("photo-1512299286776-c18be8ed6a1a"),
  volleyball: u("photo-1612872087720-bb876e2e67d1"),
  baseball: u("photo-1562183241-b937e95585b6"),
  trainingShirt: u("photo-1518310383802-640c2de311b2"),
  gymWorkout: u("photo-1517838277536-f5f99be501cd"),
  hoodie: u("photo-1663573688938-2b3e7ea2ab33"),
  jackets: u("photo-1509967419530-da38b4704bc6"),
  polos: u("photo-1714317438040-0e8584215699"),
  factorySewing: u("photo-1560796952-f1c9b838544c"),
  factoryLine: u("photo-1675176785803-bffbbb0cd2f4"),
  threads: u("photo-1517146783983-418c681b56c5"),
  craftMachine: u("photo-1524292332709-b33366a7f165"),
  aboutProduction: u("photo-1625479142928-c2f2914318f2"),
  qualityControl: u("photo-1581092160607-ee22621dd758"),
};

export const CONTACT = {
  email: "info@topplayersportswear.com",
  phoneDisplay: "+92 332 4491157",
  phoneTel: "tel:+923324491157",
  whatsapp: "https://wa.me/923324491157",
  address: "Kashmir Road, Sialkot, Pakistan",
};

export const waLink = (msg) =>
  `${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

const sportMsg = (sport) =>
  `Hi Top Player, I'm interested in custom ${sport}. I'd like to discuss my requirements and send you our design.`;

export const SPORTS = [
  { id: "hockey", name: "Hockey", img: IMAGES.hockeyRink, msg: sportMsg("hockey teamwear") },
  { id: "soccer", name: "Soccer", img: IMAGES.soccer, msg: sportMsg("soccer teamwear") },
  { id: "basketball", name: "Basketball", img: IMAGES.basketball, msg: sportMsg("basketball teamwear") },
  { id: "rugby", name: "Rugby", img: IMAGES.rugby, msg: sportMsg("rugby teamwear") },
  { id: "volleyball", name: "Volleyball", img: IMAGES.volleyball, msg: sportMsg("volleyball teamwear") },
  { id: "baseball", name: "Baseball", img: IMAGES.baseball, msg: sportMsg("baseball teamwear") },
  { id: "activewear", name: "Activewear", img: IMAGES.gymWorkout, msg: sportMsg("activewear") },
];

export const WHATSAPP_GENERIC =
  "Hi Top Player, I'm interested in custom sportswear. I'd like to discuss my requirements and send you our design.";

export const PRODUCTS = [
  "Jerseys",
  "Shorts",
  "Socks",
  "Polos",
  "Hoodies",
  "Jackets",
  "Tracksuits",
  "Training Wear",
  "Activewear",
];

export const SERVICES = [
  {
    id: "sublimation",
    name: "Custom Sublimation",
    desc: "Custom sublimated sportswear produced around the customer's design, colors and requirements.",
  },
  {
    id: "cut-sew",
    name: "Cut & Sew",
    desc: "Cut-and-sew manufacturing for custom sportswear and teamwear.",
  },
  {
    id: "printing",
    name: "Printing & Decoration",
    desc: "Printing and decoration options for customized sportswear.",
  },
  {
    id: "embroidery",
    name: "Embroidery",
    desc: "Embroidery for suitable apparel and sportswear applications.",
  },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    name: "Choose Your Sport",
    desc: "Tell us what sport and products you need.",
  },
  {
    step: "02",
    name: "Send Your Design",
    desc: "Send your logo, colors, artwork, references or existing design through WhatsApp or email.",
  },
  {
    step: "03",
    name: "Discuss Your Requirements",
    desc: "We discuss products, specifications, quantities and requirements.",
  },
  {
    step: "04",
    name: "Mockup & Approval",
    desc: "Top Player prepares the design/mockup for approval before manufacturing.",
  },
  {
    step: "05",
    name: "Manufacturing",
    desc: "Once approved, the order moves into production.",
  },
];

export const HOCKEY_GROUPS = [
  {
    id: "jerseys",
    name: "Game Jerseys",
    desc: "Custom hockey jerseys produced to your design — club colors, cresting, names and numbers, in pro-weight performance fabrics.",
    img: IMAGES.hockeyJersey,
  },
  {
    id: "pants-shells",
    name: "Pants & Shells",
    desc: "Game pant shells and covers matched to your jersey design for a complete, unified on-ice look.",
    img: IMAGES.hockeySkates,
  },
  {
    id: "socks",
    name: "Hockey Socks",
    desc: "Match and practice socks in your team striping, from classic knit to modern performance constructions.",
    img: IMAGES.hockeyStripe,
  },
  {
    id: "teamwear",
    name: "Teamwear",
    desc: "Off-ice team apparel — hoodies, jackets and travel wear that keep the roster in one identity.",
    img: IMAGES.hockeyTeam,
  },
  {
    id: "training",
    name: "Training Wear",
    desc: "Practice jerseys and training apparel built for daily rink sessions and off-ice conditioning.",
    img: IMAGES.hockeyRink,
  },
];

export const TEAM_SPORTS = [
  {
    id: "soccer",
    name: "Football / Soccer",
    desc: "Match kits, training wear and team apparel for football clubs and organizations.",
    img: IMAGES.soccer,
  },
  {
    id: "basketball",
    name: "Basketball",
    desc: "Game jerseys, shorts and warm-up apparel for basketball teams at every level.",
    img: IMAGES.basketball,
  },
  {
    id: "rugby",
    name: "Rugby",
    desc: "Durable match jerseys and teamwear built for the demands of the contact game.",
    img: IMAGES.rugby,
  },
  {
    id: "volleyball",
    name: "Volleyball",
    desc: "Lightweight game uniforms and team apparel for indoor and beach programs.",
    img: IMAGES.volleyball,
  },
  {
    id: "baseball",
    name: "Baseball",
    desc: "Jerseys, practice wear and off-field apparel for baseball teams and leagues.",
    img: IMAGES.baseball,
  },
];

export const ACTIVEWEAR_GROUPS = [
  {
    id: "shirts",
    name: "Shirts",
    desc: "Performance and team shirts produced to your design and branding.",
    img: IMAGES.trainingShirt,
  },
  {
    id: "polos",
    name: "Polos",
    desc: "Smart team polos for staff, travel days and club officials.",
    img: IMAGES.polos,
  },
  {
    id: "hoodies",
    name: "Hoodies",
    desc: "Team hoodies and fleecewear with your cresting, print or embroidery.",
    img: IMAGES.hoodie,
  },
  {
    id: "jackets",
    name: "Jackets",
    desc: "Outerwear and bench jackets carrying your team identity.",
    img: IMAGES.jackets,
  },
  {
    id: "tracksuits",
    name: "Tracksuits",
    desc: "Full tracksuits for travel, warm-ups and team presentation.",
    img: IMAGES.gymWorkout,
  },
  {
    id: "shorts-joggers",
    name: "Shorts & Joggers",
    desc: "Training shorts and joggers matched to your apparel line.",
    img: IMAGES.basketballGame,
  },
];
